module.exports = __webpack_public_path__ + "static/media/humidity.4c793c98.svg";